module.exports = __webpack_public_path__ + "img/bannerJob.037b0468.jpg";